import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projIncomeEntityList: [],
  projIncomeEntityInfo: {
    entityId: '',
    projId: '',
    entityName: '',
    entityDesc: '',
    type: '',
    ctrAcctId: '',
    tgtCtrAcctId: '',
    colId: '',
    entityContact: '',
    content: '',
    compId: '',
    colType: '',
    seq: 0,
    contractNo: '',
    status: '',
    entityStatus: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjIncomeEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_INCOME_ENTITY, {
      data: {
        entityName: state.projIncomeEntityInfo.entityName,
        type: state.projIncomeEntityInfo.type,
        ctrAcctId: state.projIncomeEntityInfo.ctrAcctId,
        tgtCtrAcctId: state.projIncomeEntityInfo.tgtCtrAcctId,
        entityContact: state.projIncomeEntityInfo.entityContact,
        content: state.projIncomeEntityInfo.content,
        contractNo: state.projIncomeEntityInfo.contractNo,
        // status: state.projIncomeEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjIncomeEntityKeyInfo({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projIncomeEntityInfo = {
      entityName: state.projIncomeEntityInfo.entityName,
      type: state.projIncomeEntityInfo.type,
      ctrAcctId: state.projIncomeEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projIncomeEntityInfo.tgtCtrAcctId,
      // entityContact: state.projIncomeEntityInfo.entityContact,
      // content: state.projIncomeEntityInfo.content,
      // contractNo: state.projIncomeEntityInfo.contractNo,
      // status: state.projIncomeEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_INCOME_ENTITY_KEY_INFO, {
      data: projIncomeEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjIncomeEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    let projIncomeEntityInfo = {
      entityName: state.projIncomeEntityInfo.entityName,
      type: state.projIncomeEntityInfo.type,
      ctrAcctId: state.projIncomeEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projIncomeEntityInfo.tgtCtrAcctId,
      entityContact: state.projIncomeEntityInfo.entityContact,
      content: state.projIncomeEntityInfo.content,
      contractNo: state.projIncomeEntityInfo.contractNo,
      // status: state.projIncomeEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_INCOME_ENTITY, {
      data: projIncomeEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjIncomeEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_INCOME_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjIncomeEntity({
    commit
  }, {entityId, projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJ_INCOME_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjIncomeEntityInfo', responseData.data)
    } else {
      commit('updateProjIncomeEntityInfo', {})
    }
  },
  async findProjIncomeEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_INCOME_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjIncomeEntityList', response)
  },
  async findProjIncomeEntityStatisticList({
    commit,
    state,
    rootState
  }, { projId, compId, searchedForm, codeParam }) {
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      // entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_RSP_PROJ_INCOME_ENTITY_STATISTIC_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjIncomeEntityList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateProjId(state, value) {
    state.projIncomeEntityInfo.projId = value
  },
  updateEntityId(state, value) {
    state.projIncomeEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.projIncomeEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.projIncomeEntityInfo.entityDesc = value
  },
  updateType(state, value) {
    state.projIncomeEntityInfo.type = value
  },
  updateCtrAcctId(state, value) {
    state.projIncomeEntityInfo.ctrAcctId = value
  },
  updateTgtCtrAcctId(state, value) {
    state.projIncomeEntityInfo.tgtCtrAcctId = value
  },
  updateColId(state, value) {
    state.projIncomeEntityInfo.colId = value
  },
  updateEntityContact(state, value) {
    state.projIncomeEntityInfo.entityContact = value
  },
  updateContent(state, value) {
    state.projIncomeEntityInfo.content = value
  },
  updateCompId(state, value) {
    state.projIncomeEntityInfo.compId = value
  },
  updateColType(state, value) {
    state.projIncomeEntityInfo.colType = value
  },
  updateSeq(state, value) {
    state.projIncomeEntityInfo.seq = value
  },
  updateContractNo(state, value) {
    state.projIncomeEntityInfo.contractNo = value
  },
  updateStatus(state, value) {
    state.projIncomeEntityInfo.status = value
  },
  updateEntityStatus(state, value) {
    state.projIncomeEntityInfo.entityStatus = value
  },
  updateLockBy(state, value) {
    state.projIncomeEntityInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.projIncomeEntityInfo.lockOn = value
  },
  updateCrtBy(state, value) {
    state.projIncomeEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.projIncomeEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.projIncomeEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.projIncomeEntityInfo.updOn = value
  },
  updateProjIncomeEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.projIncomeEntityList = response.data
    } else {
      state.projIncomeEntityList = []
    }
  },
  updateProjIncomeEntityListEmpty(state) {
    state.editIndex = -1
    state.projIncomeEntityList = []
  },
  updateProjIncomeEntityEmpty(state) {
    state.projIncomeEntityInfo.projId = ''
    state.projIncomeEntityInfo.entityId = ''
    state.projIncomeEntityInfo.entityName = ''
    state.projIncomeEntityInfo.entityDesc = ''
    state.projIncomeEntityInfo.type = ''
    state.projIncomeEntityInfo.ctrAcctId = ''
    state.projIncomeEntityInfo.tgtCtrAcctId = ''
    state.projIncomeEntityInfo.colId = ''
    state.projIncomeEntityInfo.entityContact = ''
    state.projIncomeEntityInfo.content = ''
    state.projIncomeEntityInfo.compId = ''
    state.projIncomeEntityInfo.colType = ''
    state.projIncomeEntityInfo.seq = 0
    state.projIncomeEntityInfo.contractNo = ''
    state.projIncomeEntityInfo.status = ''
    state.projIncomeEntityInfo.entityStatus = ''
    state.projIncomeEntityInfo.lockBy = ''
    state.projIncomeEntityInfo.lockOn = new Date(0)
    state.projIncomeEntityInfo.crtBy = ''
    state.projIncomeEntityInfo.crtOn = new Date(0)
    state.projIncomeEntityInfo.updBy = ''
    state.projIncomeEntityInfo.updOn = new Date(0)

    state.projIncomeEntityInfo.indUsed = ''
  },
  updateProjIncomeEntityInfo(state, projIncomeEntityInfo) {
    // debugger
    state.projIncomeEntityInfo.projId = projIncomeEntityInfo.projId
    state.projIncomeEntityInfo.entityId = projIncomeEntityInfo.entityId
    state.projIncomeEntityInfo.entityName = projIncomeEntityInfo.entityName
    state.projIncomeEntityInfo.entityDesc = projIncomeEntityInfo.entityDesc
    state.projIncomeEntityInfo.type = projIncomeEntityInfo.type
    state.projIncomeEntityInfo.ctrAcctId = projIncomeEntityInfo.ctrAcctId
    state.projIncomeEntityInfo.tgtCtrAcctId = projIncomeEntityInfo.tgtCtrAcctId
    state.projIncomeEntityInfo.colId = projIncomeEntityInfo.colId
    state.projIncomeEntityInfo.entityContact = projIncomeEntityInfo.entityContact
    state.projIncomeEntityInfo.content = projIncomeEntityInfo.content
    state.projIncomeEntityInfo.compId = projIncomeEntityInfo.compId
    state.projIncomeEntityInfo.colType = projIncomeEntityInfo.colType
    state.projIncomeEntityInfo.seq = projIncomeEntityInfo.seq
    state.projIncomeEntityInfo.contractNo = projIncomeEntityInfo.contractNo
    state.projIncomeEntityInfo.status = projIncomeEntityInfo.status
    state.projIncomeEntityInfo.entityStatus = projIncomeEntityInfo.entityStatus
    state.projIncomeEntityInfo.lockBy = projIncomeEntityInfo.lockBy
    state.projIncomeEntityInfo.lockOn = projIncomeEntityInfo.lockOn
    state.projIncomeEntityInfo.crtBy = projIncomeEntityInfo.crtBy
    state.projIncomeEntityInfo.crtOn = projIncomeEntityInfo.crtOn
    state.projIncomeEntityInfo.updBy = projIncomeEntityInfo.updBy
    state.projIncomeEntityInfo.updOn = projIncomeEntityInfo.updOn
    //
    state.projIncomeEntityInfo.indUsed = projIncomeEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjIncomeEntityManage/updateProjIncomeEntityEmpty')
    let obj = {...state.projIncomeEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.projIncomeEntityList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, type}) {
    // debugger
    this.commit('confProjIncomeEntityManage/updateProjIncomeEntityEmpty')
    this.commit('confProjIncomeEntityManage/updateEditIndex', index)
    this.commit('confProjIncomeEntityManage/updateEditAction', 'insert')
    //
    this.commit('confProjIncomeEntityManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjIncomeEntityManage/updateType', type)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjIncomeEntityManage/updateProjIncomeEntityInfo', row)
    this.commit('confProjIncomeEntityManage/updateEditIndex', index)
    this.commit('confProjIncomeEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjIncomeEntityManage.js